"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareForm = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.shareForm = (0, basic_1.applyBase)({
    detailsContainer: {
        display: ['flex', 'grid'],
        gridTemplateColumns: ['1fr', '320px 1fr'],
        flexDirection: ['column', 'row'],
        gap: [2, 3],
        pb: [2, 3],
        '.title': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.XS), { mb: [3, 0] }),
    },
    detailsImage: {
        gridRow: [null, 'span 2'],
        height: '180px',
        borderRadius: 'default',
        overflow: 'hidden',
    },
    detailsSocials: {
        alignSelf: [null, 'end'],
        gap: [4, 3],
        svg: {
            display: 'block',
            width: ['40px', '30px'],
            height: ['40px', '30px'],
        },
        mb: [2, 0],
    },
});
//# sourceMappingURL=share-form.js.map